//These error codes are from the Honeywell BarcodeReader API documentation
// /honeywell-mobility-web-sdk-v1.20.00.0901/docs/user-guide/Default.htm#BarcodeReader%20and%20BarcodeReaders%20Status%20Codes.htm%3FTocPath%3DJavaScript%2520Status%2520Codes%7C_____1

export enum BarcodeReaderStatus {
  Success = 0,
  FunctionFailed = -1994389925,
  InvalidParameter = -1994391465,
  FeatureNotSupported = -1994391502,
  InvalidSettingValue = -1994326003,
  FamilyNameNotSupported = -1994309984,
  KeyOptionNotSupported = -1994309983,
  NoActiveScannerConnection = -1994324787,
  NoJsNativeBridge = -1994309515,
  BrowserNoXmlHttpRequest = -1994309514,
  WebServiceNotResponding = -1994309513,
  MissingJsSettingsFile = -1994309512,
  InvalidJsSettingsDefinition = -1994309511,
  CommitBufferEmpty = -1994309510,
  UnknownLicenseError = -1994768767,
  LicenseExpired = -1994768766,
  LicenseManagerCannotBeCreated = -1994768765,
  NoLicenseFound = -1994768764,
  LicenseServiceCommunicationFailed = -1994768763,
  LicenseOlderThanSoftware = -1994768762,
  LicenseCheckoutTimeout = -1994768761,
}
